 <!-- password change section  -->
 <div class="inner-container-wrapper">
    <div class="titletext">
        {{'RESET_PASSWORD.TITLE_PASS_CHANGE_SUCESS' | translate}}
    </div>
    <p class="peratext-light pt16"> {{'RESET_PASSWORD.PASSWORD_SUCESS_MESSAGE' | translate}}  </p>
    <div class="pt24">
        <button class="cp-btn cp-btn-primary" (click)="helperService.goToOnlineBankingApp()"> {{redirectText}}  </button>
    </div>
</div>